import Row from './row';

import type { IAccordion } from './types';
import type { TBaseProps } from '@klv/shared/types';

const Accordion = ({
  expandedRow, isFaqsSection, rowHeadlineTag, rows, variant, showMediaInline, setExpandedRow, ...props
}: IAccordion & TBaseProps<'div'>) => (
  <div {...props}>
    {rows.map((row, index) => {
      if (row.title) {
        return (
          <Row
            expandedRow={expandedRow}
            index={index}
            isFaqsSection={isFaqsSection}
            key={JSON.stringify(row)}
            row={row}
            rowHeadlineTag={rowHeadlineTag}
            setExpandedRow={setExpandedRow}
            variant={variant}
            showMediaInline={showMediaInline}
          />
        );
      }
    })}
  </div>
);

export default Accordion;
